import { applyRemoteSports } from '@/config/sports'

const API_BASE_URL = import.meta.env.VITE_GFX_API_URL || 'https://test-fbgfx.frogbox.tv'

// The overlay waits on this before first render, so keep it short: on a
// timeout the bundled sports-snapshot.json is still a complete config.
const LOAD_TIMEOUT_MS = 3000

/**
 * Fetch the shared sport scoring config (GET /sports, FBX-2281) once per page
 * load and apply it over the bundled snapshot. Never refetched, so a config
 * change cannot alter a graphic mid-broadcast; reloading the overlay picks it
 * up. Never throws: any failure leaves the snapshot in place.
 */
export const loadSportConfig = async (): Promise<void> => {
  const controller = new AbortController()
  const timer = setTimeout(() => controller.abort(), LOAD_TIMEOUT_MS)
  try {
    const response = await fetch(`${API_BASE_URL}/sports`, { signal: controller.signal })
    if (!response.ok) throw new Error(`HTTP ${response.status}`)
    const applied = applyRemoteSports(await response.json())
    if (applied === 0) console.warn('GET /sports returned no usable sports; using bundled config')
  } catch (error) {
    console.warn('Could not load sport config; using bundled config', error)
  } finally {
    clearTimeout(timer)
  }
}
